import { defineMessages } from 'react-intl';

export default defineMessages({
  continueLabel: {
    id: 'booking.continue',
    defaultMessage: 'Continue',
  },
  step0Title: {
    id: 'booking.step_1.title',
    defaultMessage: 'Choose dates and time',
  },
  step1Title: {
    id: 'booking.step_2.title',
    defaultMessage: "Who's coming?",
  },
  step2Title: {
    id: 'booking.step_3.title',
    defaultMessage: 'Payment',
  },
});
